export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image1-ac6eae57754b3293fa0b99c5b2fe1af3.jpg";